import Socket from 'services/webSocket'
import { wsUrl } from 'config'
import { Dispatch, useCallback, useMemo } from 'react'
// import WebSocket from 'components/WebSocket'
//console.log(WebSocket)

let webSocket: Socket
export function socketInit(dispatch: Dispatch<any>) {
  webSocket = new Socket({ url: wsUrl, dispatch })
}

interface UserParamsType {
  uid: string
  token: string
}

export function useSocket() {
  const userParams = useMemo<UserParamsType>(() => {
    return {
      uid: '',
      token: '',
    }
  }, [])
  const user = window.sessionStorage.getItem('user')
  const token = localStorage.getItem('token')
  if (user !== null && user !== 'null') {
    userParams.uid = JSON.parse(user).uid
    userParams.token = token || ''
  }
  const send = useCallback(
    (params: object) => {
      if (webSocket) {
        webSocket.send({
          ...params,
          ...userParams,
        })
      }
    },
    [userParams]
  )
  return { send }
}

export function socketDestroy() {
  if (webSocket) {
    webSocket.destroy()
  }
}
